// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"2d85da8b","239":"b62d949c","453":"a5ac7fb3","455":"0437122b","977":"04dbb480"}[chunkId] + ".chunk.js";
};